// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero_wrapper__CN_72","container":"hero_container__OoGx3","list":"hero_list__uXfXC","card":"hero_card__KY2RS","icon":"hero_icon__HoZTO"};